module.exports = __webpack_public_path__ + "img/talk_login.c4d113e0.png";